<div class="font-noto tw-relative tw-px-7 tw-pt-14 tw-pb-[24px]">
  <div class="tw-absolute tw-p-1 tw-z-[100] tw-top-[16px] tw-right-[16px] tw-flex tw-justify-center close-sheet" style="width: 24px; height: 24px" (click)="closeBottomSheet()">
    <div class="tw-text-black tw-text-600 tw-font-bold">&#10005;</div>
  </div>
  <p class="tw-w-[70%] tw-mx-auto tw-text-black tw-font-bold tw-text-center tw-text-700" i18n="@@feeForCodOrders"> ₹{{data?.charges}} Handling Fee for COD orders. </p>
  <p *ngIf="!data?.isPaidUser" class="tw-w-[70%] tw-mx-auto tw-mt-2.5 tw-text-center tw-text-400 tw-text-gray-700" i18n="@@payOnlineToAvoidFee">You can pay online to avoid additional handling fee</p>
  <p *ngIf="data?.isPaidUser" class="tw-w-[70%] tw-mx-auto tw-mt-2.5 tw-text-center tw-text-400 tw-text-gray-700" i18n="@@handlingFeeForCodOrdersUnderAmount">A ₹{{data?.charges}} handling fee applies to COD orders under ₹{{data.codFeeExpVariant?.maxOrderAmount}}. Add more items or pay online to avoid paying this fee.</p>
  <button csButton
          id="continueButtonRebranded"
          type="button"
          class="tw-w-full tw-mt-7"
          style="border-radius: 9999px !important;"
          [loading]="loading"
          (click)="handleOnlineOptionClick()">
          <span [ngClass]="data.userLanguage === appConfig.Shared.Languages.TA || data.userLanguage === appConfig.Shared.Languages.TE ? 'tw-text-300' : 'tw-text-400'" i18n="@@payOnlineHandlingFee">Pay ₹{{ data?.orderSP - data?.charges }} Online</span>
  </button>
  <button csButton="outlined"
          id="CODPayButtonRebranded"
          type="button"
          class="tw-w-full tw-mt-3"
          style="border-radius: 9999px !important;"
          [loading]="loading"
          (click)="handleCODOptionClick()">
          <div class="tw-flex tw-justify-center tw-items-center tw-flex-wrap">
            <div> <span class="tw-font-normal tw-text-teal-500" [ngClass]="data.userLanguage === appConfig.Shared.Languages.TA || data.userLanguage === appConfig.Shared.Languages.TE ? 'tw-text-300' : 'tw-text-400'" i18n="@@prepaidCashOnDelivery">Cash on delivery</span> - </div>
            &nbsp; <span class="tw-text-teal-600" [ngClass]="data.userLanguage === appConfig.Shared.Languages.TA || data.userLanguage === appConfig.Shared.Languages.TE ? 'tw-text-300' : 'tw-text-400'"> <span i18n="@@codHandlingPay"> Pay ₹{{ data?.orderSP }} </span> </span>
          </div>
  </button>
</div>
